// import * as Sentry from "@sentry/angular";
/// <reference types="@angular/localize" />

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser'; // Updated import
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


// if (environment.sentryEnabled) {
//   Sentry.init({
//     dsn: "https://9e7dfe5dfca4618d6b6434d6dce1fa7b@o4510419519209472.ingest.de.sentry.io/4510504124285008",
//     integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
//     tracesSampleRate: 1,
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1,
//     enableLogs: true,
//     sendDefaultPii: true
//   });
// }

// Zone.current.fork({
//   name: 'errorHandlerZone',
//   onHandleError: (parentZoneDelegate, currentZone, targetZone, error) => {
//       console.error('Error no manejado:', error);
//       return false; // evita que el error se propague
//   },
// }).run(() => {
//   // Código inicial de la aplicación
// });

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(AppModule, {
  applicationProviders: [provideZoneChangeDetection()],
})
  .catch(err => console.error(err));
